import {isEmpty, isNotEmpty} from 'ramda';

import type {FilterValues} from '@dms/api/core';

import {WORKSHOP_SERVICE_CASE_GRID_CODE} from '../constants/workshopOverviewTiles';
import type {WorkshopDashboardFilters} from '../types/WorkshopDashboardFilters';
import type {WorkshopOverviewTileConfig} from '../types/WorkshopOverviewTileConfig';

export function getWorkshopTileFilters(
  tile: WorkshopOverviewTileConfig,
  filters: WorkshopDashboardFilters,
  orderTypeCodes: string[]
): FilterValues | null {
  const branchFilters: FilterValues = isNotEmpty(filters.branchId)
    ? {branch: [...filters.branchId].sort()}
    : {};

  // Approved temporary fallback until service-case supports associated-order filters.
  if (tile.gridCode === WORKSHOP_SERVICE_CASE_GRID_CODE) {
    return {...tile.filters, ...branchFilters};
  }

  const hasTypes = isNotEmpty(filters.serviceOrderTypeId);
  const hasVariants = isNotEmpty(filters.serviceOrderVariantId);

  const fixedTypes = tile.filters.orderType;
  const selectedTypes = Array.isArray(fixedTypes)
    ? orderTypeCodes.filter((code) => fixedTypes.includes(code))
    : orderTypeCodes;

  // Empty DG arrays are unrestricted, so incompatible selections cannot open this tile.
  if (
    hasTypes &&
    (orderTypeCodes.length !== filters.serviceOrderTypeId.length || isEmpty(selectedTypes))
  ) {
    return null;
  }

  return {
    ...tile.filters,
    ...branchFilters,
    ...(hasTypes ? {orderType: [...selectedTypes].sort()} : {}),
    ...(hasVariants ? {orderVariant: [...filters.serviceOrderVariantId].sort()} : {}),
  };
}
